import React, { useContext } from "react"
import GameContext from "../../../Context/GameContext"
import { roundStates } from "../../shared/constants"
import { RoundIntro } from "../round/RoundIntro"
import { RoundRedistribute } from "../round/RoundRedistribute"
import { RoundOutro } from "../round/RoundOutro"
import { RoundPlayerTurns } from "../round/RoundPlayerTurns"

export const GlobalRounds = props => {
  const { gameState } = useContext(GameContext)
  const roundState = gameState?.roundState

  if (!roundState) return <div>No roundState defined</div>

  switch (roundState) {
    case roundStates.INTRO:
      return <RoundIntro />
    case roundStates.PLAYER_TURNS:
      return <RoundPlayerTurns />
    case roundStates.REDISTRIBUTE:
      return <RoundRedistribute />
    case roundStates.OUTRO:
      return <RoundOutro />
    default:
      return <div>roundState invalid</div>
  }
}
